import React, { Component } from 'react';
import { MiniCard } from './MiniCard';
import { Elixir } from './Elixir';

/*import { CardButton } from './CardButton';*/

export class CardSelectBox extends Component {

  constructor(props) {
    super(props);

    this.state = {
      boxType: this.props.cardSelectType,
      cardBackground: this.props.cardBackground,
      chosen: "no",

			/*requireSelected: 1,
			suggestSelected: 0,
			banSelected: 0,*/

			warSelected: "Selected",
			requireSelected: "",
			suggestSelected: "",
			banSelected: "",

			tab: "war",
			background: "CardSelectBoxBackgroundWar",
			descriptionText: "Select all of the cards from your war collection."

    };
		//this.handleTabClick = this.handleTabClick.bind(this);

  }


	handleWarClick = () => {
		this.setState({
			/*requireSelected: 0,
			suggestSelected: 0,
			banSelected: 1,*/

			warSelected: "Selected",
			requireSelected: "",
			suggestSelected: "",
			banSelected: "",

			tab: "war",
			background: "CardSelectBoxBackgroundWar",
			descriptionText: "Select all of the cards from your war collection so deckscalibur can build you a war deck!"

		});
	}

	handleRequireClick = () => {
		this.setState({
			/*requireSelected: 1,
			suggestSelected: 0,
			banSelected: 0,*/

			warSelected: "",
			requireSelected: "Selected",
			suggestSelected: "",
			banSelected: "",

			tab: "require",
			background: "CardSelectBoxBackgroundRequire",
			descriptionText: "Want a specific card in the deck? Select it here!"

		});
	}

	handleSuggestClick = () => {
		this.setState({
			/*requireSelected: 0,
			suggestSelected: 1,
			banSelected: 0,*/

			warSelected: "",
			requireSelected: "",
			suggestSelected: "Selected",
			banSelected: "",

			tab: "suggest",
			background: "CardSelectBoxBackgroundSuggest",
			descriptionText: "Select a card to make it a bit more likely to show up."

		});
	}

	handleBanClick = () => {
		this.setState({
			/*requireSelected: 0,
			suggestSelected: 0,
			banSelected: 1,*/

			warSelected: "",
			requireSelected: "",
			suggestSelected: "",
			banSelected: "Selected",

			tab: "ban",
			background: "CardSelectBoxBackgroundBan",
			descriptionText: "The first thing you do when you load up this page is come here and select Elite Barbarians so they don't show up at all. In theory, you could do this to any card, but it was mostly made for Elite Barbarians."

		});
	}


  render() {

    return (
      <div className="CardBox CardSelectBox">



        <div className="CardBoxContainer CardSelectBox">

					<div className={ "CardBoxBackground CardSelectBoxBackground " + this.state.background } />
					<div className="CardBoxTint CardSelectBoxTint" />


          <div className="cardSelectTitle" >
            {/*<CardButton rarity="legendary" titleBackground="legendaryTitle" cardTitle={ this.state.boxType } cardBackground={ this.state.cardBackground }/>
            <CardButton rarity="legendary" titleBackground="legendaryTitle" cardTitle="use more" cardBackground="dart-goblin"/>
            <CardButton rarity="legendary" titleBackground="legendaryTitle" cardTitle="ban" cardBackground="royal-giant"/>*/}

						<div className={ "cardSelectHeader warHeader cardSelectHeader" + this.state.warSelected } onClick={this.handleWarClick}>
							<div className="cardSelectHeaderText"> War </div>
							<div className={ "cardSelectHeaderTint warTint cardSelectHeaderTint" + this.state.warSelected }/>
						</div>

						<div className={ "cardSelectHeader requireHeader cardSelectHeader" + this.state.requireSelected } onClick={this.handleRequireClick}>
							<div className="cardSelectHeaderText"> Require </div>
							<div className={ "cardSelectHeaderTint requireTint cardSelectHeaderTint" + this.state.requireSelected }/>
						</div>

						<div className={ "cardSelectHeader suggestHeader cardSelectHeader" + this.state.suggestSelected } onClick={this.handleSuggestClick}>
							<div className="cardSelectHeaderText"> Suggest </div>
							<div className={ "cardSelectHeaderTint suggestTint cardSelectHeaderTint" + this.state.suggestSelected }/>
						</div>

						<div className={ "cardSelectHeader banHeader cardSelectHeader" + this.state.banSelected} onClick={this.handleBanClick }>
							<div className="cardSelectHeaderText"> Ban </div>
							<div className={ "cardSelectHeaderTint banTint cardSelectHeaderTint" + this.state.banSelected }/>
						</div>

          </div>

					<div className="selectDescriptionText">
						{this.state.descriptionText}
					</div>

					<Elixir cost="?"/>


          <MiniCard rarity="mini" tab={ this.state.tab } cardName="mirror"/>


					<Elixir cost="1"/>


          <MiniCard rarity="mini" tab={ this.state.tab } cardName="ice-spirit"/>
          <MiniCard rarity="mini" tab={ this.state.tab } cardName="skeletons"/>
					<MiniCard rarity="mini" tab={ this.state.tab } cardName="heal"/>


					<Elixir cost="2"/>


					<MiniCard rarity="mini" tab={ this.state.tab } cardName="giant-snowball"/>
          <MiniCard rarity="mini" tab={ this.state.tab } cardName="the-log"/>
					<MiniCard rarity="mini" tab={ this.state.tab } cardName="barbarian-barrel"/>
          <MiniCard rarity="mini" tab={ this.state.tab } cardName="zap"/>
          <MiniCard rarity="mini" tab={ this.state.tab } cardName="goblins"/>
          <MiniCard rarity="mini" tab={ this.state.tab } cardName="spear-goblins"/>
          <MiniCard rarity="mini" tab={ this.state.tab } cardName="fire-spirits"/>
          <MiniCard rarity="mini" tab={ this.state.tab } cardName="bats"/>
          <MiniCard rarity="mini" tab={ this.state.tab } cardName="ice-golem"/>
          <MiniCard rarity="mini" tab={ this.state.tab } cardName="rage"/>
					<MiniCard rarity="mini" tab={ this.state.tab } cardName="wall-breakers"/>



					<Elixir cost="3"/>



          <MiniCard rarity="mini" tab={ this.state.tab } cardName="skeleton-army"/>
          <MiniCard rarity="mini" tab={ this.state.tab } cardName="archers"/>
          <MiniCard rarity="mini" tab={ this.state.tab } cardName="arrows"/>
          <MiniCard rarity="mini" tab={ this.state.tab } cardName="mega-minion"/>

          <MiniCard rarity="mini" tab={ this.state.tab } cardName="bomber"/>
          <MiniCard rarity="mini" tab={ this.state.tab } cardName="clone"/>
          <MiniCard rarity="mini" tab={ this.state.tab } cardName="tornado"/>
          <MiniCard rarity="mini" tab={ this.state.tab } cardName="knight"/>
          <MiniCard rarity="mini" tab={ this.state.tab } cardName="goblin-barrel"/>
          <MiniCard rarity="mini" tab={ this.state.tab } cardName="tombstone"/>

          <MiniCard rarity="mini" tab={ this.state.tab } cardName="ice-wizard"/>
          <MiniCard rarity="mini" tab={ this.state.tab } cardName="cannon"/>
          <MiniCard rarity="mini" tab={ this.state.tab } cardName="guards"/>
          <MiniCard rarity="mini" tab={ this.state.tab } cardName="princess"/>
          <MiniCard rarity="mini" tab={ this.state.tab } cardName="skeleton-barrel"/>
          <MiniCard rarity="mini" tab={ this.state.tab } cardName="royal-ghost"/>
          <MiniCard rarity="mini" tab={ this.state.tab } cardName="minions"/>

          <MiniCard rarity="mini" tab={ this.state.tab } cardName="bandit"/>
          <MiniCard rarity="mini" tab={ this.state.tab } cardName="miner"/>
          <MiniCard rarity="mini" tab={ this.state.tab } cardName="goblin-gang"/>
          <MiniCard rarity="mini" tab={ this.state.tab } cardName="dart-goblin"/>
					<MiniCard rarity="mini" tab={ this.state.tab } cardName="earthquake"/>
					<MiniCard rarity="mini" tab={ this.state.tab } cardName="elixir-golem"/>
					<MiniCard rarity="mini" tab={ this.state.tab } cardName="fisherman"/>
					<MiniCard rarity="mini" tab={ this.state.tab } cardName="firecracker"/>
					<MiniCard rarity="mini" tab={ this.state.tab } cardName="royal-delivery"/>



					<Elixir cost="4"/>


          <MiniCard rarity="mini" tab={ this.state.tab } cardName="baby-dragon"/>
          <MiniCard rarity="mini" tab={ this.state.tab } cardName="dark-prince"/>
          <MiniCard rarity="mini" tab={ this.state.tab } cardName="night-witch"/>

          <MiniCard rarity="mini" tab={ this.state.tab } cardName="lumberjack"/>
          <MiniCard rarity="mini" tab={ this.state.tab } cardName="battle-ram"/>
          <MiniCard rarity="mini" tab={ this.state.tab } cardName="inferno-dragon"/>
          <MiniCard rarity="mini" tab={ this.state.tab } cardName="mini-pekka"/>
          <MiniCard rarity="mini" tab={ this.state.tab } cardName="valkyrie"/>
          <MiniCard rarity="mini" tab={ this.state.tab } cardName="poison"/>
          <MiniCard rarity="mini" tab={ this.state.tab } cardName="electro-wizard"/>

          <MiniCard rarity="mini" tab={ this.state.tab } cardName="freeze"/>
          <MiniCard rarity="mini" tab={ this.state.tab } cardName="hunter"/>
          <MiniCard rarity="mini" tab={ this.state.tab } cardName="hog-rider"/>
          <MiniCard rarity="mini" tab={ this.state.tab } cardName="fireball"/>
          <MiniCard rarity="mini" tab={ this.state.tab } cardName="furnace"/>
          <MiniCard rarity="mini" tab={ this.state.tab } cardName="tesla"/>

          <MiniCard rarity="mini" tab={ this.state.tab } cardName="musketeer"/>
          <MiniCard rarity="mini" tab={ this.state.tab } cardName="mortar"/>
          <MiniCard rarity="mini" tab={ this.state.tab } cardName="flying-machine"/>
					<MiniCard rarity="mini" tab={ this.state.tab } cardName="zappies"/>
					<MiniCard rarity="mini" tab={ this.state.tab } cardName="magic-archer"/>
					<MiniCard rarity="mini" tab={ this.state.tab } cardName="bomb-tower"/>
					<MiniCard rarity="mini" tab={ this.state.tab } cardName="goblin-cage"/>
					<MiniCard rarity="mini" tab={ this.state.tab } cardName="battle-healer"/>
					<MiniCard rarity="mini" tab={ this.state.tab } cardName="skeleton-dragons"/>





					<Elixir cost="5"/>



          <MiniCard rarity="mini" tab={ this.state.tab } cardName="prince"/>
          <MiniCard rarity="mini" tab={ this.state.tab } cardName="goblin-hut"/>
          <MiniCard rarity="mini" tab={ this.state.tab } cardName="cannon-cart"/>

          <MiniCard rarity="mini" tab={ this.state.tab } cardName="minion-horde"/>
          <MiniCard rarity="mini" tab={ this.state.tab } cardName="barbarians"/>
          <MiniCard rarity="mini" tab={ this.state.tab } cardName="witch"/>
          <MiniCard rarity="mini" tab={ this.state.tab } cardName="executioner"/>
          <MiniCard rarity="mini" tab={ this.state.tab } cardName="giant"/>
          <MiniCard rarity="mini" tab={ this.state.tab } cardName="graveyard"/>
          <MiniCard rarity="mini" tab={ this.state.tab } cardName="bowler"/>

          <MiniCard rarity="mini" tab={ this.state.tab } cardName="balloon"/>
          <MiniCard rarity="mini" tab={ this.state.tab } cardName="wizard"/>
          <MiniCard rarity="mini" tab={ this.state.tab } cardName="inferno-tower"/>
					<MiniCard rarity="mini" tab={ this.state.tab } cardName="rascals"/>
					<MiniCard rarity="mini" tab={ this.state.tab } cardName="royal-hogs"/>
					<MiniCard rarity="mini" tab={ this.state.tab } cardName="electro-dragon"/>
					<MiniCard rarity="mini" tab={ this.state.tab } cardName="ram-rider"/>


					<Elixir cost="6"/>



          <MiniCard rarity="mini" tab={ this.state.tab } cardName="elixir-collector"/>
          <MiniCard rarity="mini" tab={ this.state.tab } cardName="royal-giant"/>
          <MiniCard rarity="mini" tab={ this.state.tab } cardName="x-bow"/>
          <MiniCard rarity="mini" tab={ this.state.tab } cardName="rocket"/>

          <MiniCard rarity="mini" tab={ this.state.tab } cardName="elite-barbarians"/>
          <MiniCard rarity="mini" tab={ this.state.tab } cardName="lightning"/>
          <MiniCard rarity="mini" tab={ this.state.tab } cardName="giant-skeleton"/>
          <MiniCard rarity="mini" tab={ this.state.tab } cardName="sparky"/>
					<MiniCard rarity="mini" tab={ this.state.tab } cardName="goblin-giant"/>


					<Elixir cost="7"/>


          <MiniCard rarity="mini" tab={ this.state.tab } cardName="mega-knight"/>
          <MiniCard rarity="mini" tab={ this.state.tab } cardName="barbarian-hut"/>
          <MiniCard rarity="mini" tab={ this.state.tab } cardName="lava-hound"/>
          <MiniCard rarity="mini" tab={ this.state.tab } cardName="pekka"/>
					<MiniCard rarity="mini" tab={ this.state.tab } cardName="royal-recruits"/>


					<Elixir cost="8"/>


          <MiniCard rarity="mini" tab={ this.state.tab } cardName="golem"/>


					<Elixir cost="9"/>


          <MiniCard rarity="mini" tab={ this.state.tab } cardName="three-musketeers"/>


					{/*<Elixir cost="10"/>*/}

        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/Components/CardSelectBox.js